// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"94f37d0d","217":"5ff5212d","544":"08fa5944","956":"79864fcd","963":"5ff5212d"}[chunkId] + ".chunk.css";
};